import { css } from 'lit';

export const style = css`appcues-container[data-pattern-type=shorty]{border-radius:18px}`;
